import { Contrast } from "../../../types/general.types";
import { hexToRgba } from "@icarros/utils-react";
import { ids } from "@icarros/theme-react";
import styled from "styled-components";
const { color, easing, foundation_time, foundation_fade, opacity, size } = ids || {};
export const StyledTabGroup = styled.div `
  position: relative;
  width: max-content;
  min-width: 100%;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  .activeDivider {
    position: absolute;
    bottom: 0;
    width: ${({ dividerWidth }) => dividerWidth}px;
    left: ${({ dividerOffset }) => dividerOffset}px;
    transition: all ${foundation_time.moderate.time_moderate_200ms}
      ${easing.productive.inOut.ids_easing_productive_standard};
  }
`;
export const StyledTabGroupBox = styled.div `
  position: relative;
  display: flex;
  gap: ${size.general.ids_size_general_16x};
`;
export const StyledTabItem = styled.button `
  border: 0 none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: unset;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: ${size.general.ids_size_general_8x};
  height: ${size.general.ids_size_general_56x};
  &:not(:disabled):hover {
    background-color: ${({ contrast }) => contrast === Contrast.dark
    ? hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_soft)
    : hexToRgba(color.action.neutral.ids_color_action_neutral_base, opacity.ids_opacity_soft)};
  }

  .notification-fade-in-start {
    opacity: ${foundation_fade.fade.fade_0};
  }

  .notification-fade-in-moderate-end {
    opacity: ${foundation_fade.fade.fade_100};
    transition: all ${foundation_time.moderate.time_moderate_275ms}
      ${easing.productive.inOut.ids_easing_productive_standard};
  }

  .notification-fade-out-start {
    opacity: ${foundation_fade.fade.fade_100};
  }

  .notification-fade-out-moderate-end {
    opacity: ${foundation_fade.fade.fade_0};
    transition: all ${foundation_time.moderate.time_moderate_275ms}
      ${easing.productive.inOut.ids_easing_productive_standard};
  }
`;
//# sourceMappingURL=TabGroup.style.js.map